module.exports = __webpack_public_path__ + "img/3dmousebrain-logo.4cae134c.png";